<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">故障记录</span>
        <span style="margin-left: 15px"
          >当日产生：{{ dayTotal }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 等待处理：{{
            wait
          }}</span
        >
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <span
        >系统只保留设备最近3年产生的故障记录，超过时间将自动清除，如有需要请及时人工导出报表进行备份。
      </span>
    </div>
    <div class="filter-box">
      <div class="item_box">
        <span class="subtitle">上报方式：</span>
        <Select v-model="page.type" class="fault_select">
          <Option :value="-1">全部</Option>
          <Option :value="0">自动上报</Option>
          <Option :value="1">手工上报</Option>
        </Select>
        <span class="subtitle">记录状态：</span>
        <Select v-model="page.status" class="fault_select">
          <Option :value="-1">全部</Option>
          <Option :value="0">未处理</Option>
          <Option :value="1">已处理</Option>
        </Select>
        <span class="subtitle">设备序列号：</span>
        <Input v-model="page.sn" placeholder="请输入" class="fault_select"> </Input>
      </div>
      <div class="item_box">
        <span class="subtitle">故障描述：</span>
        <Input v-model="page.log" placeholder="请输入" class="fault_select"> </Input>
        <span class="subtitle">设备站点：</span>
        <Input v-model="page.site_name" placeholder="请输入" class="fault_select">
        </Input>
        <span class="subtitle">维护管理人：</span>
        <Input v-model="page.repair_name" placeholder="请输入" class="fault_select">
        </Input>
      </div>
      <div class="item_box">
        <span class="subtitle">发生时间：</span>
        <DatePicker
          type="date"
          v-model="page.start"
          style="width: 120px"
          placeholder="开始时间"
        ></DatePicker>
        <span style="margin: 0 5px">至</span>
        <DatePicker
          type="date"
          v-model="page.end"
          style="width: 120px"
          placeholder="结束时间"
        ></DatePicker>
        <span class="subtitle" style="margin-left: 10px; margin-right: 10px"
          >企业客户：</span
        >
        <Input v-model="page.company_name" placeholder="请输入" class="fault_select">
        </Input>
        <span class="subtitle" style="margin-right: 5px">合作伙伴：</span>
        <Input
          v-model="page.agent_name"
          placeholder="请输入"
          style="margin-left: 20px"
          class="fault_select"
        >
        </Input>
      </div>
      <div class="bottom">
        <span class="btn-filter" @click="searchData()">筛选</span>
        <span class="btn" @click="reset">清空</span>
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <!-- <Button type="primary" style="margin: 0 5px 1px 0">导出Excel</Button> -->
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Button
          v-if="!agent.tp"
          :disabled="!delIds.length"
          type="error"
          @click="deleteErr"
          style="margin-left: 10px"
          >删除已选</Button
        >
      </div>
    </div>

    <div>
      <Table
        :columns="columns"
        :data="data"
        :loading="tableLoad"
        @on-selection-change="handleSelection"
      >
        <template slot-scope="{ row }" slot="describe">
          <Poptip word-wrap width="300" :content="row.describe" trigger="hover" transfer>
            <div style="width: 100px">
              <p
                style="
                  width: 100px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ row.describe }}
              </p>
            </div>
          </Poptip>
        </template>
      </Table>
      <div class="t-right">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :total="total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
      <Spin fix v-if="tableLoad">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>

    <Drawer title="详情" :closable="false" v-model="drawer.status" :width="500">
      <div v-for="(item, key) in drawer.appendix" :key="key">
        <img :src="item" alt srcset style="max-width: 100%" />
      </div>
    </Drawer>
    <Modal title="设备耗材" width="520" v-model="hc.visible">
      <Row>
        <Col span="12">
          <Card style="width: 99%" title="纸盒状态">
            <Row v-for="(item, index) in hc.data.show_tray" :key="index">
              <Col span="8">{{ ConsumablesKey[item.name] }}</Col>
              <Col span="16">
                <Progress :percent="item.value" status="active" />
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span="12">
          <Card style="width: 99%" title="碳粉状态">
            <Row v-for="(item, index) in hc.data.show_toner" :key="index">
              <Col span="8">{{ ConsumablesKey[item.name] }}</Col>
              <Col span="16">
                <Progress :percent="item.value" status="active" />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import { verifyDate, monDiff } from '@/libs/util'
export default {
  data () {
    return {
      hc: {
        visible: false,
        data: {}
      },

      page: {
        p: 0,
        l: 10,
        status: -1,
        type: -1,
        start: '',
        end: '',
        sn: '',
        log: '',
        site_name: '',
        repair_name: '',
        company_name: '',
        agent_name: '',
        andData: {}
      },
      data: [],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '编号',
          key: 'id',
          _sortKey: 'id',
          width: 100,
          search: true
        },
        {
          title: '发生时间',
          key: 'create_time',
          render: (h, data) => {
            return h('span', this.$moment(new Date(data.row.create_time)))
          },
          width: 200,
          search: true
        },
        {
          title: '上报方式',
          key: 'type',
          render: (h, data) => {
            return h('span', data.row.type == 1 ? '手工上报' : '自动上报')
          },
          width: 200,
          search: true
        },
        {
          title: '设备型号',
          key: 'type_name',
          width: 180,
          search: true
        },
        {
          title: '设备序列号',
          key: 'sn',
          width: 180,
          search: true
        },
        {
          title: '维护管理人',
          key: 'repair_name',
          width: 180,
          search: true
        },
        {
          title: '故障描述',
          key: 'log',
          width: 280,
          search: true
        },
        {
          title: '备注',
          key: 'describe',
          width: 100,
          slot: 'describe'
        },
        {
          title: '记录状态',
          key: 'status',
          render: (h, data) => {
            switch (data.row.status) {
              case 0:
                return h('div', {}, [
                  h(
                    'Button',
                    {
                      props: {
                        size: 'small',
                        type: 'error'
                      },
                      on: {
                        click: () => {
                          console.log(data.row)
                          if (data.row.type == 1) {
                            this.MachineErrorStatus({
                              id: data.row.id,
                              status: 1
                            }).then((res) => {
                              this.getList()
                            })
                          } else {
                            this.$Message.error('故障恢复后将自动改变记录状态')
                          }
                        }
                      }
                    },
                    '未处理'
                  )
                ])
                break
              case 1:
                return h('div', {}, [
                  h(
                    'Button',
                    {
                      props: {
                        size: 'small',
                        type: 'success'
                      },
                      on: {
                        click: () => {
                          console.log(data.row)
                        }
                      }
                    },
                    '已处理'
                  )
                ])
                break
            }
          },
          width: 150,
          search: true,
          searchOption: {
            type: 'select',
            vals: [
              { name: '未处理', val: 0 },
              { name: '已处理', val: 1 }
            ]
          }
        },
        {
          title: '处理人',
          key: 'contacts',
          width: 180,
          search: true
        },
        {
          title: '合作伙伴',
          key: 'agent_name',
          width: 180,
          search: true
        },
        {
          title: '站点',
          key: 'site_name',
          width: 180,
          search: true
        },
        {
          title: '企业客户',
          key: 'company_name',
          width: 180,
          search: true,
          render: (h, data) => {
            return h('span', {}, data.row.company_name ? data.row.company_name : '自营')
          }
        },
        {
          title: '客户联系人',
          key: 'company_contaccts',
          width: 180,
          search: true
        },
        {
          title: '电话',
          key: 'company_tel',
          width: 180,
          search: true
        },

        {
          title: '总印张',
          key: 'happed',
          width: 180,
          search: true
        },
        {
          title: '黑白印张',
          key: 'mono_happed',
          width: 180,
          search: true
        },
        {
          title: '彩色印张',
          key: 'color_happed',
          width: 180,
          search: true
        },

        {
          title: '结束时间',
          key: 'result_time',
          search: true,
          render: (h, data) => {
            if (data.row.status === 0) {
              return h('span', '-')
            } else return h('span', this.$moment(new Date(data.row.result_time)))
          },
          width: 200
        },
        {
          title: '操作',
          export_ignore: true,
          key: 'operate',
          render: (h, data) => {
            let btn = []
            // if (data.row.type === 1) {
            /* btn.push(
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    type: "error",
                  },
                  on: {
                    click: () => {
                      this.deleteErr(data.row.id);
                    },
                  },
                },
                "删除"
              )
            ); */
            // }
            if (data.row.toner || data.row.tray) {
              btn.push(
                h(
                  'Button',
                  {
                    props: {
                      type: 'info',
                      size: 'small'
                    },
                    style: {
                      marginLeft: '5px'
                    },
                    on: {
                      click: () => {
                        this.openHC(JSON.parse(JSON.stringify(data.row)))
                      }
                    }
                  },
                  '查看耗材'
                )
              )
            }
            if (data.row.appendix) {
              btn.push(
                h(
                  'Button',
                  {
                    props: {
                      size: 'small',
                      type: 'primary'
                    },
                    style: {
                      marginLeft: '5px'
                    },
                    on: {
                      click: () => {
                        this.openDrawer(data.row.appendixItem)
                      }
                    }
                  },
                  '附件'
                )
              )
            }
            return h('div', {}, btn)
          },
          fixed: 'right',
          width: 200
        }
      ],
      total: 0,
      dayTotal: 0,
      wait: 0,
      tableLoad: false,
      drawer: {
        status: false,
        appendix: []
      },
      ConsumablesKey: {
        black: '黑色',
        magenta: '红色',
        yellow: '黄色',
        cyan: '青色',
        manual: '手送台',
        tray1: '纸盒1',
        tray2: '纸盒2',
        tray3: '纸盒3',
        tray4: '纸盒4'
      },
      delIds: []
    }
  },
  methods: {
    ...mapActions(['MachineErrorList', 'MachineErrorDel', 'MachineErrorStatus']),
    openDrawer (appendix = []) {
      this.drawer.appendix = appendix
      this.drawer.status = true
    },
    openHC (data) {
      console.log(data)
      data.toner = JSON.parse(data.toner)
      data.show_toner = []
      data.tray = JSON.parse(data.tray)
      data.show_tray = []
      data.toner.map((item) => {
        data.show_toner.push({
          name: item.split('_')[0],
          value: parseInt(item.split('_')[1])
        })
      })
      data.tray.map((item) => {
        data.show_tray.push({
          name: item.split('_')[0],
          value: parseInt(item.split('_')[1])
        })
      })
      this.hc = {
        visible: true,
        data: data
      }
    },
    exportData (is_all) {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '故障记录'
      }
      this.columns.map((item) => {
        if (item.export_ignore) {
          return
        }
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all) {
        this.getParams()
        let cond = JSON.parse(JSON.stringify(this.page))
        cond.l = this.total
        cond.p = 0
        this.tableLoad = true
        this.MachineErrorList(cond).then((res) => {
          this.tableLoad = false
          params.data = this.formatExportData(res.data)
          excel.export_array_to_excel(params)
        })
      } else {
        params.data = this.formatExportData(this.data)
        excel.export_array_to_excel(params)
      }
    },
    formatExportData (data) {
      data = JSON.parse(JSON.stringify(data))
      data.map((item) => {
        item.create_time = this.$moment(item.create_time)
        item.type = item.type == 1 ? '手工上报' : '自动上报'
        item.status = item.status ? '已处理' : '未处理'
        item.company_name = item.company_name ? item.company_name : '自营'
        item.result_time = item.status == 0 ? '-' : this.$moment(item.result_time)
      })
      return data
    },
    searchData () {
      this.getParams()
    },
    getParams () {
      if (this.page.start && this.page.end) {
        let start = this.page.start
        let end = this.page.end
        if (verifyDate(start, end)) {
          this.$Message.error('开始时间不能大于结束时间')
          return
        }
        let diff = monDiff(this.page.start, this.page.end)
        if (diff > 1) {
          // 如果时间跨度超过一年就提示
          this.$Message.error('筛选的时间跨度不能超过1个月')
          return
        }
        this.page.start = this.$moment(this.page.start, 'YYYY-MM-DD')
        this.page.end = this.$moment(this.page.end, 'YYYY-MM-DD')
      }
      this.page.p = 0
      let temps = {}
      if (this.page.type !== -1) {
        temps.type = this.page.type
      }
      if (this.page.sn) {
        temps.sn = this.page.sn
      }
      if (this.page.log) {
        temps.log = this.page.log
      }
      if (this.page.site_name) {
        temps.site_name = this.page.site_name
      }
      if (this.page.repair_name) {
        temps.repair_name = this.page.repair_name
      }
      if (this.page.company_name) {
        temps.company_name = this.page.company_name
      }
      if (this.page.agent_name) {
        temps.agent_name = this.page.agent_name
      }
      this.page.andData = JSON.stringify(temps)

      this.getList()
    },
    getList () {
      this.tableLoad = true
      this.MachineErrorList(this.page).then((res) => {
        this.delIds = []

        this.data = res.data
        this.total = res.total
        this.tableLoad = false
        this.wait = res.wait
        this.dayTotal = res.dayTotal
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getList()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getList()
    },
    deleteErr () {
      if (!this.delIds.length) {
        this.$Message.error('请先选择删除项')
        return false
      }
      this.$Modal.confirm({
        title: '重要提醒',
        content: '确认删除已选订单吗？',
        okText: '确定',
        onOk: () => {
          const ids = [...this.delIds]
          this.MachineErrorDel({ ids }).then((res) => {
            this.$Message[res.status ? 'success' : 'error'](res.msg)
            if (!res.status) {
              return false
            }
            this.getList()
          })
        }
      })
      /* this.MachineErrorDel({ id }).then((res) => {
        this.getList();
      }); */
    },
    reset () {
      this.page = {
        p: 0,
        l: 10,
        status: -1,
        type: -1,
        start: '',
        end: '',
        sn: '',
        log: '',
        site_name: '',
        repair_name: '',
        company_name: '',
        agent_name: '',
        andData: {}
      }
      // 筛选时间为1年
      let myDate = new Date()
      // myDate.setFullYear(myDate.getFullYear() - 1);
      // myDate.setMonth(myDate.getMonth() - 1);
      this.page.start = this.$moment(myDate, 'YYYY-MM-DD')
      this.page.end = this.$moment(new Date(), 'YYYY-MM-DD')
      this.searchData()
    },
    handleSelection (rows) {
      const ids = []
      rows.map((item) => {
        ids.push(item.id)
      })
      this.delIds = ids
    }
  },
  mounted () {
    // 筛选时间为1年
    let myDate = new Date()
    // myDate.setFullYear(myDate.getFullYear() - 1);
    // myDate.setMonth(myDate.getMonth() - 2);

    this.page.start = this.$moment(myDate, 'YYYY-MM-DD')
    this.page.end = this.$moment(new Date(), 'YYYY-MM-DD')
    this.searchData()
  },
  computed: mapGetters({
    agent: 'agent'
  }),
  watch: {
    'page.status' (n, o) {
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
